<template>
  <q-btn
    size="md"
    flat
    class="btn-fixed-width q-ml-auto sm-xs xs"
    label="Search"
    no-caps
    icon-right="search"
    @click="this.$refs.searchbar.showPopup()"
  >
    <q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]"
      >Search
    </q-tooltip></q-btn
  >

  <q-select
    ref="searchbar"
    v-model.lazy="selectedSymbolModel"
    :options="optionSymbols"
    option-label="name"
    label="Search"
    clearable
    rounded
    dense
    use-input
    outlined
    @update:model-value="onSelectSymbol"
    @filter="filterSymbol"
    class="gt-xs"
    :popup-content-style="{ 'max-height': '70vw' }"
  >
    <template v-slot:option="scope">
      <q-item v-bind="scope.itemProps">
        <q-item-section avatar>
          <q-item-label class="text-bold">{{ scope.opt.symbol }}</q-item-label>
        </q-item-section>
        <q-item-section>
          <q-item-label>
            <div class="row">
              {{ scope.opt.name }}
              <q-item-label class="q-ml-auto" caption>{{
                scope.opt.type === "stock"
                  ? scope.opt.sector_name
                  : scope.opt.type === "sector"
                  ? "Sector"
                  : scope.opt.type === "index"
                  ? "Market Index"
                  : null
              }}</q-item-label>
            </div>
          </q-item-label>
        </q-item-section>
      </q-item>
    </template>
  </q-select>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";

import useData from "src/use/data";

export default {
  setup() {
    const $router = useRouter();

    const { allSymbol } = useData();

    const symbols = ref([]);
    const optionSymbols = ref([]);
    const selectedSymbolModel = ref("");

    allSymbol()
      .then((res) => {
        symbols.value = res.data.map((s) => {
          if (s.type === "stock") {
            let sector = res.data.filter(
              (item) => item.type == "sector" && item.id === s.sector_id
            )?.[0];
            return {
              id: s.id,
              name: s.name,
              symbol: s.symbol,
              type: s.type,
              sector_id: s.sector_id,
              sector_name: sector.name,
              sector_symbol: sector.symbol,
            };
          }
          return s;
        });
        optionSymbols.value = symbols.value;
      })
      .catch((error) => {
        console.log(error);
      });

    const onSelectSymbol = () => {
      if (selectedSymbolModel.value?.type === "stock") {
        $router.push({
          name: "StockProfile",
          query: {
            symbol: selectedSymbolModel.value.symbol,
          },
        });
      }
      if (selectedSymbolModel.value?.type === "sector") {
        $router.push({
          name: "SectorProfile",
          query: {
            symbol: selectedSymbolModel.value.symbol,
          },
        });
      }
      if (selectedSymbolModel.value?.type === "index") {
        $router.push({
          name: "NepalStockExchangeTechnicalCharts",
          query: {
            symbol: selectedSymbolModel.value.symbol,
          },
        });
        return;
      }
    };

    const filterSymbol = (searchText, update) => {
      if (searchText === "") {
        update(() => {
          optionSymbols.value = symbols.value;
        });
        return;
      }
      update(() => {
        const needle = searchText.toLowerCase();
        optionSymbols.value = symbols.value.filter((s) => {
          return (
            s.symbol.toLowerCase().indexOf(needle) > -1 ||
            s.name.toLowerCase().indexOf(needle) > -1 ||
            s.sector_name?.toLowerCase().indexOf(needle) > -1 ||
            s.sector_symbol?.toLowerCase().indexOf(needle) > -1 ||
            s.type.toLowerCase().indexOf(needle) > -1
          );
        });
      });
    };

    return {
      symbols,
      optionSymbols,
      console: console,

      selectedSymbolModel,

      filterSymbol,
      onSelectSymbol,
    };
  },
};
</script>
